import React from 'react'

export default function Loader(){
    return(
        <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
    )
}   